/**
 * The hero's rotating stills.
 *
 * Two or three photographs in one frame, cross-faded every 5.2 seconds — the
 * announcement bar's cadence, so the two auto-moving things on the site keep
 * the same time. WCAG 2.2.2 wants anything that moves on its own for more
 * than five seconds to be pausable, and the pause here is the same one the
 * trust ticker settled on: hover, focus, and tap — because a phone has no
 * hover and a keyboard has no tap, and either alone leaves someone with no
 * way to stop it. Under prefers-reduced-motion it never starts.
 *
 * It also stops while the tab is hidden, which is not an accessibility rule
 * but stops the fade-in from firing three at once when the tab comes back.
 */
(() => {
  const PERIOD = 5200;
  const roots = document.querySelectorAll('[data-pruvit-rotate]');
  if (!roots.length) return;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  const setup = (root) => {
    const stills = [...root.querySelectorAll('.pruvit-phero__still')];
    if (stills.length < 2) return;

    let index = Math.max(0, stills.findIndex((s) => s.classList.contains('is-on')));
    let timer = null;
    let hovered = false;
    let focused = false;
    let tapped = false;

    const show = (next) => {
      stills[index].classList.remove('is-on');
      index = next;
      stills[index].classList.add('is-on');
    };

    const step = () => show((index + 1) % stills.length);

    const shouldRun = () => !reduced.matches && !document.hidden && !hovered && !focused && !tapped;

    const sync = () => {
      if (shouldRun()) {
        if (!timer) timer = setInterval(step, PERIOD);
      } else if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };

    root.addEventListener('mouseenter', () => { hovered = true; sync(); });
    root.addEventListener('mouseleave', () => { hovered = false; sync(); });
    root.addEventListener('focusin', () => { focused = true; sync(); });
    root.addEventListener('focusout', () => { focused = false; sync(); });

    // A tap toggles. pointerup with pointerType touch, so a mouse click —
    // which already pauses by hovering — does not also latch the pause.
    root.addEventListener('pointerup', (event) => {
      if (event.pointerType !== 'touch') return;
      tapped = !tapped;
      sync();
    });

    document.addEventListener('visibilitychange', sync);
    reduced.addEventListener('change', sync);
    sync();
  };

  roots.forEach(setup);
})();
